import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private requestsCount = 0;
  private _loading$ = new Subject<boolean>();
  loading$ = this._loading$.asObservable();
  private _loadingCnt$ = new Subject<boolean>();
  loadingCnt$ = this._loadingCnt$.asObservable();
  private _excelLoadingCnt$ = new Subject<boolean>();
  excelLoadingCnt$ = this._excelLoadingCnt$.asObservable();
  show() {
    this._loading$.next(true);
  }
  hide() {
    this._loading$.next(false);
  }
  showCnt() {
    this._loadingCnt$.next(true);
  }
  hideCnt() {
    this._loadingCnt$.next(false);
  }
  showExCnt() {
    this._excelLoadingCnt$.next(true);
  }
  hideExCnt() {
    this._excelLoadingCnt$.next(false);
  }
  showLoader() {
    this.requestsCount++;    
    this._loading$.next(true);
  }
  hideLoader() {
    
    this.requestsCount--;
     if (this.requestsCount<= 0) {
         this._loading$.next(false);   
    }
  }
}
